import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import API_URLS from "../../summaryapi/apiUrls";
import favicon from "../../assets/images/V1LOGO.png"; // Your logo
import { logEmployeeAction } from "../../loginactions/index";
import {
  FaBars,
  FaChevronDown,
  FaHome,
  FaBuilding,
  FaUsers,
  FaQrcode,
  FaProjectDiagram,
  FaCircle,
  FaMoneyBillWave,
  FaBolt,
  FaGift,
  FaClipboardList,
  FaChartLine,
  FaWallet,
  FaTachometerAlt,
  FaChevronRight,
  FaShoppingCart,FaFileInvoiceDollar,
  FaBook 
} from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import { IoExitOutline } from "react-icons/io5";
import { AuthContext } from "../../common/index";
// Helper function: copies sessionStorage to localStorage and opens URL in new tab.
const openInNewTabWithSession = (url) => {
  const sessionData = {};
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    sessionData[key] = sessionStorage.getItem(key);
  }
  console.log("Storing shared session:", sessionData);
  localStorage.setItem("sharedSession", JSON.stringify(sessionData)); // Already encoded values
  const newUrl = url.includes("?") ? `${url}&shareSession=true` : `${url}?shareSession=true`;
  window.open(newUrl, "_blank", "noopener,noreferrer");
};
// Function to handle right-click event on the menu items
const handleRightClick = (e, url) => {
  e.preventDefault();
  window.open(url, "_blank");
};

const VerticalNavWrapper = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const { permissions, isLoading, adminMode } = useContext(AuthContext);
const sessionAdminMode = sessionStorage.getItem("adminMode") ? atob(sessionStorage.getItem("adminMode")) : null;
  const [adminUsername, setAdminUsername] = useState('');
  const handleSubMenuToggle = (label) => {
    // Only toggle submenu if sidebar is open
    if (isSidebarOpen) {
      setOpenSubMenu((prevState) => (prevState === label ? null : label));
    } else {
      // If sidebar is closed, just open the sidebar
      setIsSidebarOpen(true);
    }
  };
  useEffect(() => {
    const activeSubMenu = navItems.find((item) =>
      item.content?.some((subItem) => subItem.to === currentPath)
    );
    if (activeSubMenu) {
      setOpenSubMenu(activeSubMenu.label);
    } else {
      setOpenSubMenu(null);
    }
  }, [currentPath]);

  const MainNav = [{ label: "Home", to: "/dashboards/crm", icon: <FaHome /> , screenId: "39" }];

useEffect(() => {
  // Set initial value
  setAdminUsername(sessionStorage.getItem("adminUsername") ? atob(sessionStorage.getItem("adminUsername")) : '');
  
  // Optional: Listen for storage events
  const handleStorageChange = () => {
    setAdminUsername(sessionStorage.getItem("adminUsername") ? atob(sessionStorage.getItem("adminUsername")) : '');
  };
  
  window.addEventListener('storage', handleStorageChange);
  return () => window.removeEventListener('storage', handleStorageChange);
}, []);
  const CompanyNav = [
    {
      label: "MASTERS",
      icon: <FaBuilding />,
      content: [
        { label: "Create District", to: "/addcompany/district", screenId: "1" },
        { label: "Create Company", to: "/addcompany/company", screenId: "2" },
        { label: "Create Group", to: "/addcompany/group", screenId: "3" },
        { label: "Create Employee", to: "/addcompany/employee", screenId: "4" },
        { label: "Change Pwd", to: "/addcompany/changepassword", screenId: "6" },
        { label: "Add A Banners",  to: "/addcompany/addbanner", screenId: "40" },
        // { label: "Mobile App Permissions", to: "/" },
        { label: "Add Announcements", to: "/addcompany/addannouncement", screenId: "46" },
        // { label: "Add Media Announcements", to: "/" },
        // { label: "Get Members Pwd", to: "/" },
        { label: "Roles And Responsibilities", to: "/addcompany/rolesandresponsbilities" },
        // { label: "ASSIGN DEALERS", to: "/addcompany/assigndealers", screenId: "42" },
        // { label: "Employee Logs", to: "/addcompany/activitylogs", screenId: "" },

              { label: "Dealer Cards", to: "/addcompany/dealerflags", screenId: "" },
      { label: "Dealer Passwords", to: "/addcompany/dealerpasswords", screenId: "" },
      ],
    },
  ];

  const UploadPoints = [
    {
      label: "Upload Points",
      icon: <FaWallet />,
      content: [
        { label: "Upload Admin Electrician Points", to: "/uploadPoints/electriciantransferpoints" , screenId: "5" },
      ],
    },
  ];

  const PersonnelNav = [
    {
      label: "Create/View",
      icon: <FaUsers />,
      content: [
        { label: "Manager", to: "/addpersonnel/manager", screenId: "7" },
        { label: "Sales Executive", to: "/addpersonnel/representative", screenId: "8" },
        { label: "Dealer", to: "/addpersonnel/dealer", screenId: "9" },
        { label: "SalesBoy", to: "/addpersonnel/salesboy", screenId: "10" },
        { label: "Electrician", to: "/addpersonnel/electrician", screenId: "11" },
        { label: "Dealer App Login Report", to: "/addpersonnel/dealerapplogin", screenId: "47" },
      ],
    },
  ];

  const SchemesNav = [
    {
      label: "Schemes",
      icon: <FaClipboardList />,
      content: [
        { label: "Dealer Scheme", to: "/giftscheme/dealergiftscheme", screenId: "25"  },
        { label: "SalesBoy Scheme", to: "/" },
        { label: "Electrician Scheme", to: "/giftscheme/electriciangiftscheme", screenId: "12" },
      ],
    },
  ];

  const QrNav = [
    {
      label: "Qrcode",
      icon: <FaQrcode />,
      content: [
        { label: "Generate QR Codes", to: "/qrcode/qrcodes", screenId: "13" },
        // { label: "NEW QR CODES", to: "/qrcode/qrreports", screenId: "14" },
        // { label: "Used QR CODES", to: "/qrcode/usedqrcodes", screenId: "15" },
        { label: "Search Qr Code Status", to: "/qrcode/SearchQrCodeStatus", screenId: "34" },
        { label: "Qr Reports", to: "/qrcode/qrcreatedreport", screenId: "43" },
      ],
    },
  ];

  const PointsNav = [
    {
      label: "Transfer Points",
      icon: <FaMoneyBillWave />,
      content: [
        { label: "Dealer To Electrician", to: "/points/electriciantransferpoints", screenId: "16" },
        { label: "Dealer To Salesboy", to: "/points/salesboytransferpoints", screenId: "17" },
      ],
    },
  ];



  const GiftSalesboy = [
    {
      label: "GIFT Management SalesBoy",
      icon: <FaGift />,
      content: [
        { label: "Select Gift", to: "/" },
        { label: "Gift Delivery Pending or Delivered", to: "/" },
      ],
    },
  ];

  const TotalReports = [
    {
      label: "Reports",
      icon: <FaChartLine />,
      content: [
        { label: "Electrician Reports", to: "/records/electricianReports", screenId: "20" },
        { label: "Dealer Reports", to: "/records/dealerReports", screenId: "24" },

      ],
    },
  ];


  const PersonalDashBoard = [
    {
      label: "Personal DashBoard",
      icon: <FaTachometerAlt  />,
      content: [
        { label: "Electrician Dashboard", to: "/personaldashboard/electriciandashboard",  screenId: "21"},
        { label: "Dealer Dashboard", to: "/personaldashboard/dealerdashboard",  screenId: "23"},
        { label: "SalesBoy Dashboard", to: "/personaldashboard/salesboydashboard",  screenId: "38"},
        { label: "Sales Executive Dashboard", to: "/personaldashboard/salesexcutivedashboard",  screenId: "41"},
        { label: "MothWise Reports", to: "/personaldashboard/dealermonthwisereports",  screenId: "47"}
      ],
    },
  ];


 
  const LedgerReport = [
    {
      label: "Ledger Report",
      icon: <FaBook />,
      content: [
        { label: "Electrician LedgerReport", to: "/reports/electricianledgerreports",  screenId: "22"},
        { label: "Dealer LedgerReport", to: "/reports/dealerledgerreports",  screenId: "26"},
      ],
    },
  ];





  const GiftElectrician = [
    {
      label: "GIFT Management Electrician",
      icon: <FaGift />,
      content: [
        { label: "Select Electrician Gift", to: "/giftmanagementelectirician/reedemgift" ,screenId: "18" },
        { label: "Gift Delivery Pending or Delivered", to: "/giftmanagementelectirician/giftdeveliveredorpending" ,screenId: "19"},
        { label: "Make Electrician Points Empty", to: "/" },
        { label: "Electrician Gift Hold", to: "/giftmanagementelectirician/gifthold",  screenId: "35" },
        { label: "Electrician Gift Cancel", to: "/giftmanagementelectirician/electriciangiftcancel",  screenId: "44" },
      ],
    },
  ];



  const GiftDealer = [
    {
      label: "GIFT Management Dealer",
      icon: <FaGift />,
      content: [
        { label: "Select Dealer Gift", to: "/giftmanagementDealer/selectgift" ,screenId: "37" },
        { label: "Update Gift Dispatch details", to: "/giftmanagementDealer/giftdeveliveredorpendingdealer", screenId: "27" },
        { label: "Dealer Gift Hold", to: "/giftmanagementDealer/dealergifthold", screenId: "36" },
        { label: "Dealer Gift Cancel", to: "/giftmanagementDealer/dealergiftcancel",  screenId: "45" },
      ],
    },
  ];

  const SaleOrders = [
    {
      label: "Sale Orders",
      icon: <FaShoppingCart />,
      content: [
        { label: "Item Management", to: "/saleorders/item-management" , screenId: "28" },
        { label: "Item Positions", to: "/saleorders/item-positions" , screenId: "29" },
        { label: "Order Management", to: "/saleorders/order-management" , screenId: "30" },
        { label: "Edit Orders", to: "/saleorders/edit-orders" , screenId: "31" },
        { label: "Invoice", to: "/saleorders/in-voice" , screenId: "32" },
        { label: "Order History", to: "/saleorders/dealer-orderhistory" , screenId: "33" },
  { label: "Order Creation", to: "/saleorders/order-creation", screenId: "48" },

      ],
    },
  ];

  const TalleyData = [
    {
      label: "Tally Data",
      icon: <FaFileInvoiceDollar />,
      content: [
        { label: "DAY BOOK", to: "/talleyData/daybook", screenId: "" },
        { label: "Duplicate GUIDS", to: "/talleyData/duplicate-guids", screenId: "" },
        { label: "Company Master", to: "/talleyData/companymaster", screenId: "" },
        { label: "Group Master", to: "/talleyData/groupmaster", screenId: "" },
        { label: "Dealer Debit Note", to: "/talleyData/dealernote", screenId: "" },
        { label: "Dealer Credit Note", to: "/talleyData/dealercreditnote", screenId: "" },
        { label: "Dealer Journal", to: "/talleyData/dealerjournal", screenId: "" },
        { label: "Dealer Receipt", to: "/talleyData/dealerreceipt", screenId: "" },
        { label: "Dealer Purchase", to: "/talleyData/dealerpurchase", screenId: "" },
        { label: "Dealer Sales", to: "/talleyData/dealersales", screenId: "" },
        { label: "Dealer Payments", to: "/talleyData/dealerpayments", screenId: "" },
       { label: "Dealer OnAccount", to: "/talleyData/dealeronaccountbalance" , screenId: "" },
      ],
    },
  ];


  const Sales = [
    {
      label: "Sales",
      icon: <FaFileInvoiceDollar  />,
      content: [
        { label: "sales returns", to: "/sales/salesreturns" , screenId: "" },
        { label: "Dealer LedgerStatement", to: "/talleyData/dealerledgercopy" , screenId: "" },
        { label: "Dealer Creditdaylimits", to: "/sales/creditdaylimits" , screenId: "" },
        { label: "Dealer OverDueBills", to: "/sales/odoverduebills" , screenId: "" },
        { label: "Dealer Discounts", to: "/sales/dealerdiscount" , screenId: "" },
      ],
    },
  ];







  const navItems = [
    ...MainNav,
    ...CompanyNav,
    ...UploadPoints,
    ...PersonnelNav,
    ...SchemesNav,
    ...QrNav,
    ...GiftDealer,
    ...GiftElectrician,
    // ...GiftSalesboy,
    ...TotalReports,
    ...PersonalDashBoard,
    ...LedgerReport,
    ...SaleOrders,
    ...PointsNav,
   ...TalleyData,
   ...Sales
  ];


  
const filteredNavItems = navItems
  .map(item => {
    // Handle Home separately
    if (item.label === "Home") {
      return item;
    }

    if (item.label === "Sales") {
      return null;
    }

    // Exclude these items from the sidebar for everyone
    if (item.label === "Personal DashBoard" || item.label === "Ledger Report" || 
        item.label === "Delear Dashboard" || item.label === "MothWise Reports" ||
        item.label === "Edit Orders") {
      return null;
    }

    // For Admin, show all Sale Orders items except the excluded ones
    if (sessionAdminMode === "Admin" && item.label === "Sale Orders") {
      if (item.content) {
        const filteredContent = item.content.filter(subItem => 
          subItem.label !== "Item Positions" && 
          subItem.label !== "Edit Orders" && 
          subItem.label !== "Invoice" &&  
          subItem.label !== "Order History"
        );
        if (filteredContent.length > 0) {
          return {...item, content: filteredContent};
        }
        return null;
      }
      return item;
    }

    // FOR EMPLOYEE - Specific handling for Sale Orders
    if (sessionAdminMode === "Employee" && item.label === "Sale Orders") {
      if (item.content) {
        const filteredContent = item.content.filter(subItem => {
          // Exclude unwanted items
          if (["Item Positions", "Edit Orders", "Invoice", "Order History"].includes(subItem.label)) {
            return false;
          }
          // For Order Creation (screenId 48), check permission
          if (subItem.label === "Order Creation") {
            console.log('Order Creation permission check:', permissions['48']?.is_access);
            return permissions['48']?.is_access === true;
          }
          // For other items, check their permissions
          if (subItem.screenId && permissions[subItem.screenId]) {
            return permissions[subItem.screenId].is_access === true;
          }
          return false;
        });
        return filteredContent.length > 0 ? {...item, content: filteredContent} : null;
      }
      return null;
    }

    // For Employee - Other menu items
    if (sessionAdminMode === "Employee") {
      if (item.content && item.content.length > 0) {
        const filteredSubItems = item.content.filter(subItem => {
          if (subItem.screenId && permissions[subItem.screenId]) {
            return permissions[subItem.screenId].is_access === true;
          }
          return false;
        });
        return filteredSubItems.length > 0 ? { ...item, content: filteredSubItems } : null;
      } else {
        return item.screenId && permissions[item.screenId]?.is_access === true ? item : null;
      }
    }

    // If Admin, return all items
    return item;
  })
  .filter(Boolean);
 // Remove null values to exclude unwanted items
  const isNavItemSelected = (item) =>
    currentPath === item.to ||
    (item.content && item.content.some((subItem) => currentPath === subItem.to));

const renderNavItems = () => {
  return filteredNavItems.map((item, index) => {
    const isSelected = isNavItemSelected(item);
    if (item.content) {
      return (
        <li key={index} className="nav-item" style={{ marginBottom: "6px" }}>
          <Link
            to={item.to || "#"}
            className={`d-flex align-items-center py-1 px-3 text-white text-decoration-none rounded`}
            onClick={(e) => {
              e.preventDefault();
              if (!isSidebarOpen) {
                setIsSidebarOpen(true);
              } else {
                handleSubMenuToggle(item.label);
              }
            }}
style={{
  backgroundColor: isSelected ? "rgba(255, 255, 255, 0.15)" : "transparent", // subtle white overlay
  color: "#fff",
  transition: "all 0.3s ease",
  padding: "8px 12px",
  borderRadius: "8px",
  fontWeight: isSelected ? "500" : "400"
}}


          >
            <span
              className={`mr-2 ${!isSidebarOpen ? "icon-medium" : ""}`}
              style={{ fontSize: isSidebarOpen ? "18px" : "22px" }}
            >
              {item.icon}
            </span>
            {isSidebarOpen && (
              <>
                <span className="text-uppercase" style={{ 
                  fontSize: "10px", 
                  paddingLeft: "8px",
                  lineHeight: "1.3"
                }}>
                  {item.label}
                </span>
                <FaChevronDown
                  style={{
                    marginLeft: "auto",
                    transform: openSubMenu === item.label ? "rotate(180deg)" : "rotate(0deg)",
                    fontSize: "13px"
                  }}
                />
              </>
            )}
          </Link>
          {isSidebarOpen && openSubMenu === item.label && (
            <ul className="list-unstyled pl-3" style={{ marginTop: "4px" }}>
              {item.content.map((subItem, subIndex) => {
                const isSubItemSelected = currentPath === subItem.to;
                return (
                  <li key={subIndex} className="nav-item" style={{ marginBottom: "3px" }}>
                    <Link
                      to={subItem.to || "#"}
                      className={`d-flex align-items-center py-1 px-3 text-white text-decoration-none rounded`}
                      onContextMenu={(e) => {
                        handleRightClick(e, subItem.to);
                      }}
style={{
  backgroundColor: isSubItemSelected ? "rgba(0, 0, 0, 0.3)" : "transparent", // dark transparent
  transition: "all 0.3s ease",
  paddingLeft: isSidebarOpen ? "32px" : "20px",
  marginTop: subIndex === 0 ? "6px" : "0",
  borderLeft: isSubItemSelected ? "4px solid #fff" : "4px solid transparent",
  fontSize: "10px",
  color: "#fff", // white text
  fontWeight: isSubItemSelected ? "500" : "400",
  borderRadius: "0 8px 8px 0" // smooth right curve
}}


                    >
                      {isSidebarOpen && (
                        <span className="text-uppercase" style={{ 
                          fontSize: "10px",
                          paddingLeft: "6px"
                        }}>
                          {subItem.label}
                        </span>
                      )}
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      );
    } else {
      return (
        <li key={index} className="nav-item" style={{ marginBottom: "6px" }}>
          <Link
            to={item.to || "#"}
            className={`d-flex align-items-center py-1 px-3 text-white text-decoration-none rounded`}
            onClick={() => {
              if (!isSidebarOpen) setIsSidebarOpen(true);
            }}
            style={{
              backgroundColor: isSelected ? "rgba(0, 0, 0, 0.3)" : "transparent",
              transition: "background-color 0.3s ease",
            }}
          >
            <span
              className={`mr-2 ${!isSidebarOpen ? "icon-medium" : ""}`}
              style={{ fontSize: isSidebarOpen ? "18px" : "22px" }}
            >
              {item.icon}
            </span>
            {isSidebarOpen && (
              <span className="text-uppercase" style={{ 
                fontSize: "10px",
                paddingLeft: "8px",
                lineHeight: "1.3"
              }}>
                {item.label}
              </span>
            )}
          </Link>
        </li>
      );
    }
  });
};






const clearSessionAndCookies = () => {
  const ConfirmLogout = ({ closeToast }) => (
    <div>
      <p>Are you sure you want to logout?</p>
      <div style={{ display: "flex", justifyContent: "space-around", marginTop: "10px" }}>
        <button
          className="btn btn-danger"
          onClick={async () => {
            // Log the logout action before clearing session
            await logEmployeeAction('LOGOUT');
            sessionStorage.clear();
            toast.success("Logged out successfully!", { autoClose: 3000 });
            closeToast();
            setTimeout(() => {
              window.location.href = "/Dhanshakthi-AdminLogin";
            }, 2000);
          }}
        >
          Yes, Logout
        </button>
        <button className="btn btn-secondary" onClick={closeToast}>
          No, Cancel
        </button>
      </div>
    </div>
  );
    toast.warn(<ConfirmLogout />, {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      hideProgressBar: true,
    });
  };

  return (
   <Fragment>
      <div
        className={`sidebar text-white position-fixed ${isSidebarOpen ? "sidebar-open" : "sidebar-collapsed"}`}
        style={{
          height: "100vh",
          width: isSidebarOpen ? "260px" : "80px",
          position: "fixed",
          transition: "width 0.3s ease",
          top: 0,
          left: 0,
          zIndex: 1000,
          overflow: "hidden", // Prevent content overflow
          background: "linear-gradient(135deg,rgb(172, 37, 44), #ff4b5c,rgb(172, 35, 35))",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Logo and User Info Section */}
        <div 
          className="d-flex flex-column justify-content-between align-items-center p-4" 
          style={{ 
            marginTop: isSidebarOpen ? "4rem" : "2rem",
            flexShrink: 0 // Prevent this section from shrinking
          }}
        >
          <Link to="/dashboards/crm" className="d-flex flex-column align-items-center">
            {isSidebarOpen && (
              <div className="mt-2 d-flex align-items-center" style={{ flexDirection: adminMode === "Admin" ? "row" : "column" }}>
                <img
                  src={favicon}
                  alt="Logo"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    marginRight: adminMode === "Admin" ? "10px" : "0",
                    marginBottom: adminMode === "Employee" ? "5px" : "0"
                  }}
                />
                {sessionAdminMode === "Admin" ? (
                  <h1 className="mb-0 text-white">Admin</h1>
                ) : (
                  <h1 className="mb-0 text-white">{adminUsername || 'Employee'}</h1>
                )}
              </div>
            )}
            {!isSidebarOpen && (
              <img
                src={favicon}
                alt="Logo"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%"
                }}
              />
            )}
          </Link>
        </div>

        {/* Scrollable Navigation Items */}
        <div 
          className="p-2" 
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(255,255,255,0.3) transparent",
            '&::-webkit-scrollbar': {
              width: "6px",
            },
            '&::-webkit-scrollbar-track': {
              background: "transparent",
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "3px",
            },
          }}
        >
          <ul className="list-unstyled" style={{ paddingBottom: "60px" }}>{renderNavItems()}</ul>
        </div>
        
        {/* Fixed Logout Button */}
        <div
          className="logout-container"
          style={{
            backgroundColor: "rgb(172, 35, 35)",
            padding: "10px 0",
            textAlign: "center",
            cursor: "pointer",
            zIndex: 1000,
            flexShrink: 0, // Prevent this section from shrinking
          }}
          onClick={clearSessionAndCookies}
        >
          <IoExitOutline size={isSidebarOpen ? 20 : 24} className="text-white" />
          <span className={`text-white ${!isSidebarOpen ? "d-none" : ""}`}>Logout</span>
        </div>
  
        {/* Sidebar Toggle Button */}
        <div
          className="sidebar-toggle-btn position-absolute"
          style={{
            top: isSidebarOpen ? "60px" : "20px",
            right: "20px",
            cursor: "pointer",
            zIndex: 1000,
            transition: "top 0.3s ease"
          }}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? (
            <FaBars style={{ fontSize: "28px" }} />
          ) : (
            <FaChevronRight style={{ fontSize: "28px" }} />
          )}
        </div>
      </div>
      
      <div
        className="main-content"
        style={{
          marginLeft: isSidebarOpen ? "250px" : "80px",
          transition: "margin-left 0.3s ease",
          padding: "20px",
        }}
      ></div>
    </Fragment>























  );
};

export default VerticalNavWrapper;